/** Internal dependencies */
import { fadeIn, fadeOut } from '../utilities';

// what is the exact difference to loadmoreStart? Could it be handled in one function?
/**
 * Toggle visibility of the loading spinner, if it exists. Also toggle appropriate classes on the parent
 *
 * @author Kosh <kosh@cubetech.ch>
 * @author rafhun <rafhun@cubetech.ch>
 * @export
 * @param {HTMLElement} parent Parent element
 * @param {boolean} [show=true] Should the spinner be shown or hidden?
 */
export function loadingSpinner(parent, show = true) {
    const { ctRestInstance } = parent.dataset;
    const spinner = parent.querySelector(`[data-ct-spinner="${ctRestInstance}"]`);
    if (spinner) {
        // Can we do this based on parent class we add?
        show ? fadeIn(spinner) : fadeOut(spinner);
    }

    show ? parent.classList.add('loading') : parent.classList.remove('loading');
}

/**
 * Toggle visibility of the loadmore spinner and appropriate classes on the parent.
 *
 * @author Kosh <kosh@cubetech.ch>
 * @author rafhun <rafhun@cubetech.ch>
 * @export
 * @param {HTMLElement} parent Parent element
 * @param {boolean} [show=true] Should the spinner be shown or hidden?
 */
export function loadmoreSpinner(parent, show = true) {
    const { ctRestInstance } = parent.dataset;
    const spinner = parent.querySelector(`[data-ct-loadmore-spinner="${ctRestInstance}"]`);

    if (spinner) {
        show ? fadeIn(spinner) : fadeOut(spinner);
    }

    show ? parent.classList.add('loadmore') : parent.classList.remove('loadmore');
}
